import Head from 'next/head';

export const RatingSchema = () => (
  <Head>
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
            "@context":"https://schema.org/",
            "@type":"Product",
            "name":"Mutual Fund Investment Online in India",
            "description":"Invest in the best performing mutual funds online with ClearTax. We also provide Complete Guide to Mutual Funds, Types of Mutual Funds, Best Funds to Buy, Mutual Fund Calculators, Fund Offers, Latest NAVs, and latest mutual fund news.",
            "url":"https://cleartax.in/mutual-funds",
            "image": "https://assets1.cleartax-cdn.com/cleartax-brand/logos/2018/01/pinchy_yellow_black.png",
            "brand":{"@type":"Organization","name":"ClearTax"},
            "aggregateRating":{"@type":"AggregateRating","ratingValue":4.84,"bestRating":"5","ratingCount":"9786"},
            "sku":"NA",
            "mpn":"NA",
            "review":{"@type":"Review","reviewBody":"","author":{"@type":"Organization","name":"ClearTax"}}
        }`,
      }}
    />
  </Head>
);



// WEBPACK FOOTER //
// ./components/homePageNew/ratingSchema.tsx